import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { tracking } from "shared/data";
import { notEmpty } from "shared/lib/utils";

import type { heroSecondaryArticlesHomeV2QueueItemsEdge$key } from "scmp-app/queries/__generated__/heroSecondaryArticlesHomeV2QueueItemsEdge.graphql";

import { Container, StyledContentItemHomeSecondary } from "./styles";

type Props = {
  className?: string;
  clickTrackingFunction: (entityId?: string) => void;
  reference: heroSecondaryArticlesHomeV2QueueItemsEdge$key;
};

export const HomeV2HeroSecondaryArticles: FunctionComponent<Props> = ({
  className,
  clickTrackingFunction,
  reference,
}) => {
  const items = useFragment(
    graphql`
      fragment heroSecondaryArticlesHomeV2QueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Content {
            entityId
            ...homeSecondaryV2ContentItemContent
          }
        }
      }
    `,
    reference,
  );

  if (!notEmpty(items)) return null;
  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: tracking.module.TopStory,
      }}
    >
      <Container className={className}>
        {items.map(({ node }) => (
          <StyledContentItemHomeSecondary
            key={node.entityId}
            onClick={clickTrackingFunction}
            reference={node}
            withComment
            withExclusiveHeaderFlag
            withImage
            withLiveTag
            withSection
            withSeriesShortLabel
          />
        ))}
      </Container>
    </BaseLinkContextProvider>
  );
};

HomeV2HeroSecondaryArticles.displayName = "HomeV2HeroSecondaryArticles";
